module.exports = __webpack_public_path__ + "img/turbo-features5.4a026a9e.png";